import { combineReducers } from 'redux-immutable'
import Error from './error/reducer'
import Sessions from '../scenes/Dates/services/reducer'
import Options from '../scenes/Options/services/reducer'

export const rootReducer = combineReducers({
  error: Error,
  sessions: Sessions,
  options: Options
})
export default rootReducer
